import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import SellTab from "./SellTab";

function CustomQueries () {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SellTab />
      <Footer />
    </DashboardLayout>
  );
}

export default CustomQueries;
